/* plugins/pdf-exporter/assets/js/pdf-exporter.js — the PDF Exporter page: three report types (analytics, SEO,
   ecommerce), a live preview of what each PDF will say, download, and per-site defaults. */
if (typeof window !== "undefined" && typeof window.TR === "undefined") { window.TR = function (k, v) { return (window.GS && GS.t) ? GS.t(k, v) : k; }; }
(function () {
  "use strict";
  var TR = window.TR;
  try { (window.GS_BUILD = window.GS_BUILD || {})["pdf-exporter"] = "1.1.0"; } catch (e) {}

  var META = { sections: [], presets: [], page_sizes: [], orientations: [], types: ["analytics"] };
  var SEL = { type: "analytics", audience: "all", preset: "last_30_days", from: null, to: null, page_size: "A4", orientation: "portrait", device: "", country: "", rows: 15 };
  var seq = 0;

  function q(k) { return document.querySelector('[data-px="' + k + '"]'); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function site() { return (window.GS && GS.site) || ""; }
  function t(k, fb, v) { var s = TR(k, v); return (s && s !== k) ? s : fb; }
  function fillSelect(el, items, valFn, labFn, cur) {
    if (!el) return;
    el.innerHTML = items.map(function (it) { var v = valFn(it); return '<option value="' + esc(v) + '"' + (v === cur ? " selected" : "") + '>' + esc(labFn(it)) + '</option>'; }).join("");
  }
  function selectedSections() {
    var s = [].slice.call(document.querySelectorAll("[data-px-sec]:checked")).map(function (c) { return c.value; });
    return s.length ? s : null;
  }
  function body() {
    return {
      type: SEL.type, audience: SEL.audience,
      date_preset: SEL.preset || null, date_start: SEL.from, date_end: SEL.to,
      sections: SEL.type === "analytics" ? selectedSections() : null, rows: +((q("rows") || {}).value || 15),
      filters: SEL.type === "analytics" ? { device: SEL.device || null, country: SEL.country || null } : {},
      title: (q("title") || {}).value || "", filename: (q("filename") || {}).value || "",
      page_size: SEL.page_size, orientation: SEL.orientation
    };
  }

  /* ---- report type ---- */
  var PH = { analytics: ["px.b_title_ph", "Analytics Report"], seo: ["px.title_ph_seo", "SEO report"], ecommerce: ["px.title_ph_ecom", "Ecommerce report"] };
  var NOTE = {
    analytics: ["px.p_note", "The PDF opens with this KPI summary, then one table per selected section."],
    seo: ["px.p_note_seo", "The PDF opens with these scores and a summary, then one to-do per problem — who it is for, why it matters, what to do and on which pages — and ends with page-by-page tables."],
    ecommerce: ["px.p_note_ecom", "The PDF opens with these figures against the period before, then what the numbers say, the purchase funnel, products, where revenue comes from and the latest orders."]
  };
  function setType(type, silent) {
    if ((META.types || []).indexOf(type) < 0) type = "analytics";
    SEL.type = type;
    [].forEach.call(document.querySelectorAll("[data-px-type]"), function (b) {
      var on = b.getAttribute("data-px-type") === type;
      b.classList.toggle("is-on", on); b.setAttribute("aria-checked", on ? "true" : "false");
    });
    [].forEach.call(document.querySelectorAll("[data-px-only]"), function (el) {
      el.hidden = el.getAttribute("data-px-only").split(" ").indexOf(type) < 0;
    });
    var ti = q("title"); if (ti) ti.placeholder = t(PH[type][0], PH[type][1]);
    var rl = q("rows-label"); if (rl) rl.textContent = type === "seo" ? t("px.b_rows_seo", "Pages listed per to-do") : (type === "ecommerce" ? t("px.b_rows_ecom", "Rows per table") : t("px.b_rows", "Rows per section"));
    var n = q("preview-note"); if (n) n.textContent = t(NOTE[type][0], NOTE[type][1]);
    try { history.replaceState(null, "", location.pathname + location.search + (type === "analytics" ? "" : "#" + type)); } catch (e) {}
    if (!silent) preview();
  }

  function buildSections() {
    var host = q("sections"); if (!host) return;
    host.innerHTML = META.sections.map(function (s) {
      return '<label class="px-sec"><input type="checkbox" data-px-sec value="' + esc(s.key) + '" checked> ' + esc(s.label) + '</label>';
    }).join("");
  }

  /* ---- preview ---- */
  function kpi(v, l, sub, tone) {
    return '<div class="px-kpi"><div class="px-kpi-v">' + esc(v) + '</div><div class="px-kpi-l">' + esc(l) + '</div>'
      + (sub ? '<div class="px-kpi-s' + (tone ? " is-" + tone : "") + '">' + esc(sub) + '</div>' : "") + '</div>';
  }
  function tone(good) { return good === true ? "good" : (good === false ? "bad" : "warn"); }
  function changeTone(txt, upGood) {
    if (!txt) return ""; var neg = /^-/.test(txt); if (/^[+-]0\.0%/.test(txt)) return "";
    return (neg !== upGood) ? "good" : "bad";
  }

  function renderAnalytics(d) {
    var kh = q("preview-kpis"); kh.className = "px-kpis";
    kh.innerHTML = kpi(Number(d.kpis.pageviews).toLocaleString(), TR("pdfexp.g.pageviews")) + kpi(Number(d.kpis.visitors).toLocaleString(), TR("pdfexp.g.visitors"))
      + kpi(Number(d.kpis.sessions).toLocaleString(), TR("pdfexp.g.sessions"));
    q("preview-sections").innerHTML = '<div class="px-muted mb-1" style="font-size:12px">' + esc(t("px.p_included", "Included in this report:")) + '</div>' + d.sections.map(function (s) {
      return '<div class="px-secrow"><span>' + esc(s.label) + '</span><span class="px-badge">' + esc(s.rows === 1 ? t("px.p_rows_1", "1 row") : t("px.p_rows", s.rows + " rows", { n: s.rows })) + '</span></div>';
    }).join("");
  }

  function renderSeo(d) {
    var kh = q("preview-kpis"); kh.className = "px-kpis px-kpis-4";
    var K = d.kpis || {}, none = t("px.nodata", "No data yet");
    var cell = function (k, label) { return K[k] ? kpi(K[k].value, label, K[k].sub, tone(K[k].good)) : kpi("—", label, none, ""); };
    kh.innerHTML = cell("indexable", t("px.k_indexable", "Indexable pages")) + cell("vitals", t("px.k_vitals", "Core Web Vitals"))
      + cell("design", t("px.k_design", "Design audit")) + cell("organic", t("px.k_organic", "Satisfied searchers"));
    var T = d.todos || { total: 0, by_priority: {}, by_role: {}, top: [] }, h = "";
    var pr = T.by_priority || {};
    h += '<div class="px-sum"><b>' + esc(T.total === 1 ? t("px.todos_1", "1 to-do") : t("px.todos_n", T.total + " to-dos", { n: T.total })) + '</b>';
    ["high", "medium", "low"].forEach(function (p) { if (pr[p]) h += ' <span class="px-pri is-' + p + '">' + esc(pr[p] + " " + t("px.pri_" + p, p)) + '</span>'; });
    h += '</div>';
    if (d.audience === "all" && T.total) {
      var r = T.by_role || {}, parts = [];
      ["developer", "designer", "content"].forEach(function (w) { if (r[w]) parts.push(esc(t("px.aud_" + w, w)) + " " + r[w]); });
      h += '<div class="px-muted" style="font-size:12px">' + parts.join(" &middot; ") + '</div>';
    }
    if (T.top && T.top.length) {
      h += '<div class="px-muted mt-2 mb-1" style="font-size:12px">' + esc(t("px.p_first", "First in the report:")) + '</div>';
      h += T.top.map(function (x) {
        return '<div class="px-todo"><span class="px-dot is-' + esc(x.priority) + '" aria-label="' + esc(t("px.pri_" + x.priority, x.priority)) + '"></span>'
          + '<span class="px-todo-t">' + esc(x.title) + '</span><span class="px-todo-m">' + esc(x.audience) + ' &middot; ' + esc(x.pages === 1 ? t("px.pages_1", "1 page") : t("px.pages_n", x.pages + " pages", { n: x.pages })) + '</span></div>';
      }).join("");
    } else if (!T.total) {
      h += '<div class="px-empty">' + esc(t("px.seo_none", "No to-dos for this selection. The data sources below show what the report can see.")) + '</div>';
    }
    h += '<div class="px-muted mt-3 mb-1" style="font-size:12px">' + esc(t("px.p_sources", "Data sources")) + '</div>';
    h += (d.sources || []).map(function (s) {
      return '<div class="px-src"><i class="bi ' + (s.has ? "bi-check-circle-fill is-good" : "bi-dash-circle is-warn") + '" aria-hidden="true"></i><div><div class="px-src-n">'
        + esc(s.name) + '</div><div class="px-muted" style="font-size:12px">' + esc(s.note) + '</div></div></div>';
    }).join("");
    q("preview-sections").innerHTML = h;
  }

  function renderEcom(d) {
    var kh = q("preview-kpis");
    if (!d.has_data) {
      kh.className = "px-kpis"; kh.innerHTML = "";
      q("preview-sections").innerHTML = '<div class="px-empty">' + esc(d.available === false
        ? t("px.ecom_missing", "The Ecommerce Tracking plugin is not installed, so there is no shop data to report on.")
        : t("px.ecom_none", "No ecommerce events in this period. Enable Ecommerce Tracking for this site and send its events from your shop; the PDF will explain how.")) + '</div>';
      return;
    }
    kh.className = "px-kpis px-kpis-4";
    var L = { revenue: t("px.k_revenue", "Revenue"), orders: t("px.k_orders", "Orders"), aov: t("px.k_aov", "Average order"), conv: t("px.k_conv", "Conversion rate") };
    kh.innerHTML = (d.kpis || []).map(function (k) {
      var c = k.change ? k.change.replace(" vs previous period", "") : null;
      return kpi(k.value, L[k.label] || k.label, c ? t("px.vs_prev", c + " vs before", { c: c }) : null, changeTone(c, true));
    }).join("");
    var h = "";
    if (d.findings && d.findings.length) {
      h += '<div class="px-muted mb-1" style="font-size:12px">' + esc(t("px.p_findings", "What the numbers say:")) + '</div><ul class="px-find">'
        + d.findings.map(function (f) { return "<li>" + esc(f) + "</li>"; }).join("") + "</ul>";
    }
    h += '<div class="px-muted" style="font-size:12px">' + esc(t("px.p_ecom_counts", d.products + " products, " + d.orders + " orders", { p: d.products, o: d.orders })) + '</div>';
    q("preview-sections").innerHTML = h;
  }

  function preview() {
    if (!site()) return;
    var my = ++seq;
    var sh = q("preview-sections"); if (sh) sh.classList.add("is-busy");
    GS.api("/plugin/pdf-exporter/preview?site=" + encodeURIComponent(site()), { method: "POST", body: JSON.stringify(body()) }).then(function (r) {
      if (my !== seq) return;                                   // a newer preview is on its way
      if (sh) sh.classList.remove("is-busy");
      var d = r && r.data; if (!d || !d.ok) return;
      var lbl = q("range-label"); if (lbl && d.range) lbl.textContent = d.range.from + " → " + d.range.to;
      if (d.type === "seo") renderSeo(d); else if (d.type === "ecommerce") renderEcom(d); else renderAnalytics(d);
    });
  }

  function download() {
    if (!site()) return;
    var btn = q("download"); if (btn) { btn.disabled = true; }
    var pt = (window.GSUI && GSUI.progressToast) ? GSUI.progressToast(t("pdf.a.building_pdf", "Building PDF…")) : { update: function () {}, done: function () {} };
    pt.update(t("pdf.a.building_pdf", "Building PDF…"), 40);
    var st = q("status"); if (st) st.textContent = t("pdf.a.building_pdf", "Building PDF…");
    GS.api("/plugin/pdf-exporter/export?site=" + encodeURIComponent(site()), { method: "POST", body: JSON.stringify(body()) }).then(function (r) {
      if (btn) btn.disabled = false;
      var d = r && r.data;
      if (!d || !d.ok) { pt.done(t("pdf.a.export_failed", "Export failed."), "error"); if (st) st.textContent = t("pdf.a.export_failed", "Export failed."); return; }
      var bin = atob(d.b64), len = bin.length, bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) bytes[i] = bin.charCodeAt(i);
      var blob = new Blob([bytes], { type: d.mime || "application/pdf" });
      var url = URL.createObjectURL(blob), a = document.createElement("a");
      a.href = url; a.download = d.filename; document.body.appendChild(a); a.click();
      setTimeout(function () { URL.revokeObjectURL(url); a.remove(); }, 1000);
      pt.done(TR("pdfexp.g.downloaded") + d.filename, "success");
      if (st) st.textContent = TR("pdfexp.g.downloaded") + d.filename + ".";
    });
  }

  function saveSettings() {
    var b = { default_preset: (q("set-preset") || {}).value || "last_30_days", page_size: (q("set-pagesize") || {}).value || "A4", orientation: (q("set-orientation") || {}).value || "portrait" };
    GS.api("/plugin/pdf-exporter/save-settings?site=" + encodeURIComponent(site()), { method: "POST", body: JSON.stringify(b) }).then(function (r) {
      var n = q("save-note"); if (n) { n.hidden = false; n.textContent = (r && r.data && r.data.ok) ? t("px.saved", "Saved.") : TR("pdfexp.g.save_failed"); setTimeout(function () { n.hidden = true; }, 1500); }
    });
  }
  function loadSettings() {
    GS.api("/plugin/pdf-exporter/settings?site=" + encodeURIComponent(site())).then(function (r) {
      var c = r && r.data && r.data.config;
      if (c) {
        if (c.default_preset) { SEL.preset = c.default_preset; var pe = q("preset"); if (pe) pe.value = c.default_preset; var sp = q("set-preset"); if (sp) sp.value = c.default_preset; var cw = q("custom-range"); if (cw) cw.hidden = !!c.default_preset; }
        if (c.page_size) { SEL.page_size = c.page_size; var ps = q("page-size"); if (ps) ps.value = c.page_size; var sps = q("set-pagesize"); if (sps) sps.value = c.page_size; }
        if (c.orientation) { SEL.orientation = c.orientation; var o = q("orientation"); if (o) o.value = c.orientation; var so = q("set-orientation"); if (so) so.value = c.orientation; }
      }
      preview();
    });
  }
  function load() {
    GS.api("/plugin/pdf-exporter/sections?site=" + encodeURIComponent(site())).then(function (r) {
      var d = r && r.data; if (!d || !d.ok) return;
      META = d; if (!META.types) META.types = ["analytics"];
      buildSections();
      fillSelect(q("preset"), [{ p: "" }].concat(d.presets.map(function (p) { return { p: p }; })), function (x) { return x.p; }, function (x) { return x.p ? x.p.replace(/_/g, " ") : TR("pdfexp.g.custom_range"); }, SEL.preset);
      fillSelect(q("page-size"), d.page_sizes.map(function (s) { return { s: s }; }), function (x) { return x.s; }, function (x) { return x.s.toUpperCase(); }, SEL.page_size);
      fillSelect(q("orientation"), d.orientations.map(function (o) { return { o: o }; }), function (x) { return x.o; }, function (x) { return x.o.charAt(0).toUpperCase() + x.o.slice(1); }, SEL.orientation);
      var h = (location.hash || "").replace("#", "");
      setType(h === "seo" || h === "ecommerce" ? h : SEL.type, true);
      loadSettings();
    });
  }

  var timer = null;
  function soon() { clearTimeout(timer); timer = setTimeout(preview, 350); }
  document.addEventListener("change", function (e) {
    var tg = e.target, k = tg && tg.getAttribute && tg.getAttribute("data-px");
    if (k === "preset") { SEL.preset = tg.value; var cw = q("custom-range"); if (cw) cw.hidden = !!tg.value; preview(); }
    else if (k === "from") { SEL.from = tg.value; if (!SEL.preset) preview(); }
    else if (k === "to") { SEL.to = tg.value; if (!SEL.preset) preview(); }
    else if (k === "page-size") { SEL.page_size = tg.value; }
    else if (k === "orientation") { SEL.orientation = tg.value; }
    else if (k === "device") { SEL.device = tg.value; preview(); }
    else if (k === "country") { SEL.country = tg.value; preview(); }
    else if (k === "audience") { SEL.audience = tg.value; preview(); }
    else if (k === "rows") { SEL.rows = +tg.value; if (SEL.type === "analytics") soon(); }
    else if (tg && tg.hasAttribute && tg.hasAttribute("data-px-sec")) { soon(); }
  });
  document.addEventListener("click", function (e) {
    var ty = e.target && e.target.closest && e.target.closest("[data-px-type]");
    if (ty) { setType(ty.getAttribute("data-px-type")); return; }
    var b = e.target && e.target.closest && e.target.closest("[data-px-btn]"); if (!b) return;
    var k = b.getAttribute("data-px-btn");
    if (k === "download") download(); else if (k === "preview") preview(); else if (k === "save-settings") saveSettings();
  });
  document.addEventListener("keydown", function (e) {             // arrow keys move between the report types (radio group)
    var ty = e.target && e.target.closest && e.target.closest("[data-px-type]");
    if (!ty || (e.key !== "ArrowRight" && e.key !== "ArrowLeft")) return;
    var all = [].slice.call(document.querySelectorAll("[data-px-type]")), i = all.indexOf(ty);
    var nx = all[(i + (e.key === "ArrowRight" ? 1 : all.length - 1)) % all.length];
    e.preventDefault(); nx.focus(); setType(nx.getAttribute("data-px-type"));
  });
  document.addEventListener("gs:ready", function () { load(); });
  document.addEventListener("gs:site-change", function () { load(); });
  if (window.GS && GS.site) load();
})();
